import type { ZoneDTO } from "../api/client";
import type { FilterConditionDTO } from "@/shared/contracts/base";
import {
  findCondition,
  removeConditions,
  upsertCondition,
} from "@/shared/contracts/query-helpers";
import { SimpleSelect } from "@/shared/ui/SimpleSelect";
import { useNavigate, useSearch } from "@tanstack/react-router";

const ALL_VALUE = "__all__";

type RatesFilterProps = {
  zones: ZoneDTO[];
};

export function RatesFilter({ zones }: RatesFilterProps) {
  const nav = useNavigate({ from: "/app/shipping/rates" });
  const search = useSearch({ from: "/app/shipping/rates" }) as {
    limit?: number;
    offset?: number;
    sort?: Array<{ field: string; dir: "asc" | "desc" }> | string;
    filters?: FilterConditionDTO[] | string;
  };

  const filters = (search.filters as FilterConditionDTO[] | undefined) ?? [];
  const zoneFilter = findCondition(filters, "zoneId");

  const zoneValue = (zoneFilter?.value as string) || "";

  const applyZone = (val: string) => {
    const effective = val === ALL_VALUE ? "" : val;
    const nextFilters = effective
      ? upsertCondition(filters, {
          field: "zoneId",
          op: "eq",
          value: effective,
        })
      : removeConditions(filters, "zoneId") ?? [];
    nav({
      search: {
        ...search,
        offset: 0,
        filters: nextFilters?.length ? nextFilters : undefined,
      } as any,
    });
  };

  const zoneOptions = [
    { label: "ທຸກໂຊນ", value: ALL_VALUE },
    ...zones.map((z) => ({ label: z.code, value: z.id })),
  ];

  return (
    <div
      className="mb-4 flex flex-wrap items-center gap-4 px-2"
      data-tourid="shipping-rates-filter"
    >
      <SimpleSelect
        placeholder="ໂຊນ"
        className="h-8 w-[180px]"
        value={zoneValue || ALL_VALUE}
        onValueChange={applyZone}
        options={zoneOptions}
      />
    </div>
  );
}
